import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a1c8ba1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "product-promotion-section"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" This broker is eligible for the ")
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CollapsibleSection = _resolveComponent("CollapsibleSection")!

  return (_ctx.hasPromotion)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_CollapsibleSection, {
          collapsed: _ctx.isCollapsed,
          onToggleCollapse: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle()))
        }, {
          caption: _withCtx(() => [
            _createElementVNode("b", {
              innerHTML: _ctx.promotionName()
            }, null, 8, _hoisted_2)
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", null, [
              _hoisted_3,
              _createElementVNode("b", {
                innerHTML: _ctx.promotionName()
              }, null, 8, _hoisted_4)
            ])
          ]),
          _: 1
        }, 8, ["collapsed"])
      ]))
    : _createCommentVNode("", true)
}